import {Component, Input, OnInit} from '@angular/core';
import {Player} from "../../../model/broadcast/player";
import {Broadcast} from "../../../model/broadcast/broadcast";
import {UtilService} from "../../../services/util.service";
import {ControlAction} from "../../../model/broadcast/control";
import {DecimalPipe, NgForOf, NgIf} from "@angular/common";
import {Game} from "../../../model/broadcast/game";

@Component({
  selector: 'app-batter',
  templateUrl: './batter.component.html',
  styleUrls: ['./batter.component.scss'],
  imports: [
    NgIf,
    NgForOf
  ],
  standalone: true
})
export class BatterComponent implements OnInit {

  @Input() broadcast: Broadcast;
  @Input() player: Player;
  @Input() controlAction: ControlAction;

  constructor(
    public utilService: UtilService,
    private decimalPipe: DecimalPipe,
  ) { }

  ngOnInit(): void {
  }

  getNumber(): string {
    return this.utilService.getNumber(this.player, this.broadcast);
  }

  getName(): string {
    return this.utilService.getName(this.player, this.broadcast);
  }

  getTeamBgr(): string {
    return this.utilService.getTeamBgr(this.player, this.broadcast);
  }

  getBgrWithOverlay(): string {
    return this.utilService.getBgrWithOverlay(this.player, this.broadcast);
  }

  formatAvg(avg: number): string {
    if(!avg) return '-';
    const transform: string = this.decimalPipe.transform(avg, '0.3-3');
    return Number(transform) < 1 ? transform.substr(1) : transform;
  }
}
